import { createSlice } from '@reduxjs/toolkit';
import { insightsReducer } from './reducer';
import { initialState } from './initialState';
import {
  getInvoicingExpensesInsightsAction,
  getInvoicingRevenueInsightsAction
} from './actions';
import { InsightsType } from './insightTypes';

export const insightsSlice = createSlice({
  name: 'insights',
  initialState,
  reducers: insightsReducer,
  extraReducers: {
    [getInvoicingExpensesInsightsAction.pending.toString()]: (state: InsightsType) => ({
      ...state,
      fetching: true
    }),
    [getInvoicingExpensesInsightsAction.fulfilled.toString()]: (state: InsightsType, { payload }) => {
      const { success, message, result, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code
        }
      }

      return {
        ...state,
        fetching: false,
        invoicingExpensesInsightsData: result,
        statusCode: status_code
      }
    },
    [getInvoicingExpensesInsightsAction.rejected.toString()]: (state: InsightsType, { error }) => ({
      ...state,
      fetching: false,
      error: error?.message
    }),
    [getInvoicingRevenueInsightsAction.pending.toString()]: (state: InsightsType) => ({
      ...state,
      fetching: true
    }),
    [getInvoicingRevenueInsightsAction.fulfilled.toString()]: (state: InsightsType, { payload }) => {
      const { success, message, result, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code
        }
      }

      return {
        ...state,
        fetching: false,
        invoicingRevenueInsightsData: result,
        statusCode: status_code
      }
    },
    [getInvoicingRevenueInsightsAction.rejected.toString()]: (state: InsightsType, { error }) => ({
      ...state,
      fetching: false,
      error: error?.message
    })
  }
});

export const {
  resetError: resetInsightsError,
  resetSuccess: resetInsightsSuccess,
  resetInsightsFetching,
  resetInvoicingExpensesInsightsData,
  resetInvoicingRevenueInsightsData
} = insightsSlice.actions;

